import React from 'react'
import { useSelector } from 'react-redux'
import { Navigate, Route, Routes } from 'react-router-dom'

import Auth from '@pages/Auth'
import Branches from '@pages/Branches/index'
import BalancePage from '@pages/Cash/Balance/index'
import SendMoney from '@pages/Cash/SendMoney/index'
import Cashs from '@pages/Cashs/index'
import Clients from '@pages/Clients'
import DashboardWorkers from '@pages/DashboardWorkers'
import Debtors from '@pages/Debtors'
import CheckDebtors from '@pages/DebtorsCheck'
import DebtorsSalesPerson from '@pages/DebtorsSalesPerson'
import DeliveryReport from '@pages/DeliveryReport'
import Employees from '@pages/Employees/index'
import ExpectedPayments from '@pages/ExpectedPayments/index'
import ExportPerfectCut from '@pages/ExportPerfectCut'
import FinishedSales from '@pages/FinishedSales'
import GoodIssueReport from '@pages/GoodIssueReport'
import GrossProfitReport from '@pages/GrossProfitReport'
import IgnoredSalesOrders from '@pages/IgnoredSalesOrders'
import Items from '@pages/Items'
import ItemsAdmin from '@pages/ItemsAdmin'
import ItemsPriceForShapes from '@pages/ItemsPriceForShapes'
import ItemsServices from '@pages/ItemsServices/index'
import ItemsServicesTable from '@pages/ItemsServicesTable'
import ItemsShapes from '@pages/ItemsShapes'
import ItemShapesTable from '@pages/ItemsShapesTable'
import ItemsTable from '@pages/ItemsTable'
import LandedCosts from '@pages/LandedCosts/index'
import MarshrutPage from '@pages/MarshrutPage/index'
import MarshrutPageForWorkers from '@pages/MarshrutPageForWorkers'
import MarshrutPageInvoices from '@pages/MarshrutPageInvoice'
import MySalesAdmin from '@pages/MySalesAdmin'
import MySalesSlp from '@pages/MySalesSlp'
import NotFound from '@pages/NotFound'
import OrderPage from '@pages/OrderPage'
import OrderProfit from '@pages/OrderProfit'
import PackageOfServices from '@pages/PackageOfSerivces/index'
import PaymentDistribution from '@pages/PaymentDistribution'
import IncomingPayments from '@pages/Payments/IncomingPayments/index'
import OutgoingPayments from '@pages/Payments/OutgoingPayments'
import ProductionOrders from '@pages/ProductionOrder'
import ProductionWorkers from '@pages/ProductionWorkers'
import ProductionWorkersAdmin from '@pages/ProductionWorkersAdmin'
import ProductionManagementDone from '@pages/ProductionWorkersDone'
import PurchaseIncoming from '@pages/PurchaseIncoming'
import PurchaseInvoices from '@pages/PurchaseInvoices'
import PurchaseOrder from '@pages/PurchaseOrder'
import CreatePurchaseOrder from '@pages/PurchaseOrder/createPurchaseOrder'
import ReceiptPage from '@pages/Receipt'
import Reports from '@pages/Reports/index'
import Sales from '@pages/Sales'
import SalesMiniDashboard from '@pages/SalesMiniDashboard'
import SalesOrder from '@pages/SalesOrder'
import CreateSales from '@pages/SalesOrder/Create'
import CreateSalesCopy from '@pages/SalesOrder/CreateCopy'
import EditSalesOrder from '@pages/SalesOrder/Edit'
import SalesOrderRequestAdmin from '@pages/SalesOrderRequestAdmin'
import SalesPersonKPI from '@pages/SalesPersonKpi'
import SeeSales from '@pages/SeeSales'
import SeeSalesCustomers from '@pages/SeeSalesCustomers'
import SeriesBarcodePage from '@pages/SeriesBarcodePage'
import AdminSeriesBarcodePage from '@pages/SeriesBarcodePageAdmin'
import ProdManagerSeriesBarcodePage from '@pages/SeriesBarcodePageProdManager'
import OneSeriesBarcodePage from '@pages/SeriesOneBarcodePage'
import ShippedSales from '@pages/ShippedSales'
import StockTransfers from '@pages/StockTranfers/index'
import Suppliers from '@pages/Suppliers/index'

import MasterReports from '../pages/MasterReports/index';
import SalesReportsByDepartment from '../pages/SalesReportsByDepartment/index';
import ServiceReports from '../pages/ServiceReports/index';

const ProtectedRoute = ({ element: Component, ...rest }) => {
	const isAuthenticated = useSelector((state) => state.main.isAuthenticated)
	return isAuthenticated ? (
		<Component {...rest} />
	) : (
		<Navigate to="/auth" replace />
	)
}

const RoutesComponent = () => {
	const isAuthenticated = useSelector((state) => state.main.isAuthenticated)
	const prevLocation = sessionStorage.getItem('prevLocation')

	return (
		<Routes>
			<Route
				path="/"
				element={
					<Navigate
						to={
							isAuthenticated
								? prevLocation || '/my-sales-slp'
								: '/auth'
						}
						replace
					/>
				}
			/>
			<Route path="/auth" element={<Auth />} />
			<Route
				path="/prod-gross-profit-report"
				element={<ProtectedRoute element={GrossProfitReport} />}
			/>
			<Route
				path="/delivery-report"
				element={<ProtectedRoute element={DeliveryReport} />}
			/>
			<Route
				path="/payment-distribution"
				element={<ProtectedRoute element={PaymentDistribution} />}
			/>
			<Route
				path="/sales-order-request"
				element={<ProtectedRoute element={SalesOrderRequestAdmin} />}
			/>
			<Route
				path="/good-issue-report"
				element={<ProtectedRoute element={GoodIssueReport} />}
			/>
			<Route
				path="/service-reports"
				element={<ProtectedRoute element={ServiceReports} />}
			/>
			<Route
				path="/sales-reports-by-department"
				element={<ProtectedRoute element={SalesReportsByDepartment} />}
			/>
			<Route
				path="/master-reports"
				element={<ProtectedRoute element={MasterReports} />}
			/>
			<Route
				path="/series-one-barcode"
				element={<ProtectedRoute element={OneSeriesBarcodePage} />}
			/>
			<Route
				path="/admin-series-barcode"
				element={<ProtectedRoute element={AdminSeriesBarcodePage} />}
			/>
			<Route
				path="/prod-manager-series-barcode"
				element={
					<ProtectedRoute element={ProdManagerSeriesBarcodePage} />
				}
			/>
			<Route
				path="/prod-workers-admin"
				element={<ProtectedRoute element={ProductionWorkersAdmin} />}
			/>
			<Route
				path="/ignored-sales-orders"
				element={<ProtectedRoute element={IgnoredSalesOrders} />}
			/>
			<Route
				path="/purchase-order"
				element={<ProtectedRoute element={PurchaseOrder} />}
			/>
			<Route
				path="/orders"
				element={<ProtectedRoute element={OrderPage} />}
			/>
			<Route
				path="/marshrut"
				element={<ProtectedRoute element={MarshrutPage} />}
			/>
			<Route
				path="/invoicesMarshrut"
				element={<ProtectedRoute element={MarshrutPageInvoices} />}
			/>
			<Route
				path="/purchase-incoming"
				element={<ProtectedRoute element={PurchaseIncoming} />}
			/>
			<Route
				path="/purchase-invoices"
				element={<ProtectedRoute element={PurchaseInvoices} />}
			/>
			<Route
				path="/production-orders"
				element={<ProtectedRoute element={ProductionOrders} />}
			/>
			<Route
				path="/production-workers"
				element={<ProtectedRoute element={ProductionWorkers} />}
			/>{' '}
			<Route
				path="/production-workers-done"
				element={<ProtectedRoute element={ProductionManagementDone} />}
			/>
			<Route path="/items" element={<ProtectedRoute element={Items} />} />
			<Route
				path="/itemsAdmin"
				element={<ProtectedRoute element={ItemsAdmin} />}
			/>
			<Route
				path="/itemsAdmin"
				element={<ProtectedRoute element={ItemsAdmin} />}
			/>
			<Route
				path="/itemsShapes"
				element={<ProtectedRoute element={ItemsShapes} />}
			/>
			<Route
				path="/itemsPriceForShapes"
				element={<ProtectedRoute element={ItemsPriceForShapes} />}
			/>
			<Route
				path="/itemsShapesTable"
				element={<ProtectedRoute element={ItemShapesTable} />}
			/>
			<Route
				path="/itemsServices"
				element={<ProtectedRoute element={ItemsServices} />}
			/>
			<Route
				path="/expected-payments"
				element={<ProtectedRoute element={ExpectedPayments} />}
			/>
			<Route
				path="/branches"
				element={<ProtectedRoute element={Branches} />}
			/>
			<Route path="/cashs" element={<ProtectedRoute element={Cashs} />} />
			<Route
				path="/salesMiniDashboard"
				element={<ProtectedRoute element={SalesMiniDashboard} />}
			/>
			<Route
				path="/itemsTable"
				element={<ProtectedRoute element={ItemsTable} />}
			/>
			<Route
				path="/servicesTable"
				element={<ProtectedRoute element={ItemsServicesTable} />}
			/>
			<Route
				path="/receipt"
				element={<ProtectedRoute element={ReceiptPage} />}
			/>
			<Route
				path="/export-perfect-cut"
				element={<ProtectedRoute element={ExportPerfectCut} />}
			/>
			<Route
				path="/landed-costs"
				element={<ProtectedRoute element={LandedCosts} />}
			/>
			<Route
				path="/suppliers"
				element={<ProtectedRoute element={Suppliers} />}
			/>
			<Route
				path="/marshrut-for-workers"
				element={<ProtectedRoute element={MarshrutPageForWorkers} />}
			/>
			<Route
				path="/series-barcode"
				element={<ProtectedRoute element={SeriesBarcodePage} />}
			/>
			<Route
				path="/create-purchase-order"
				element={<ProtectedRoute element={CreatePurchaseOrder} />}
			/>
			<Route
				path="/stock-transfers"
				element={<ProtectedRoute element={StockTransfers} />}
			/>
			<Route
				path="/employees"
				element={<ProtectedRoute element={Employees} />}
			/>
			<Route
				path="/dashboard-workers"
				element={<ProtectedRoute element={DashboardWorkers} />}
			/>
			<Route
				path="/package-services"
				element={<ProtectedRoute element={PackageOfServices} />}
			/>
			<Route
				path="/see-sales"
				element={<ProtectedRoute element={SeeSales} />}
			/>
			<Route
				path="/see-sales-customers"
				element={<ProtectedRoute element={SeeSalesCustomers} />}
			/>
			<Route
				path="/my-sales-admin"
				element={<ProtectedRoute element={MySalesAdmin} />}
			/>
			<Route
				path="/my-sales-slp"
				element={<ProtectedRoute element={MySalesSlp} />}
			/>
			<Route
				path="/sales-order"
				element={<ProtectedRoute element={SalesOrder} />}
			/>
			<Route
				path="/sales-order/add"
				element={<ProtectedRoute element={CreateSales} />}
			/>
			<Route
				path="/sales-order/add-copy"
				element={<ProtectedRoute element={CreateSalesCopy} />}
			/>
			<Route
				path="/sales-order/:docEntry"
				element={<ProtectedRoute element={EditSalesOrder} />}
			/>
			<Route
				path="/debtors"
				element={<ProtectedRoute element={Debtors} />}
			/>
			<Route
				path="/finished-sales"
				element={<ProtectedRoute element={FinishedSales} />}
			/>
			<Route path="/sales" element={<ProtectedRoute element={Sales} />} />
			<Route
				path="/outgoing-payments"
				element={<ProtectedRoute element={OutgoingPayments} />}
			/>
			<Route
				path="/incoming-payments"
				element={<ProtectedRoute element={IncomingPayments} />}
			/>
			<Route
				path="/balance"
				element={<ProtectedRoute element={BalancePage} />}
			/>
			<Route
				path="/check-debtors"
				element={<ProtectedRoute element={CheckDebtors} />}
			/>
			<Route
				path="/sales-person-debtors"
				element={<ProtectedRoute element={DebtorsSalesPerson} />}
			/>
			<Route
				path="/sales-person-kpi"
				element={<ProtectedRoute element={SalesPersonKPI} />}
			/>
			<Route
				path="/order-profit"
				element={<ProtectedRoute element={OrderProfit} />}
			/>
			<Route
				path="/send-money"
				element={<ProtectedRoute element={SendMoney} />}
			/>
			<Route
				path="/reports"
				element={<ProtectedRoute element={Reports} />}
			/>
			<Route
				path="/shipped-sales"
				element={<ProtectedRoute element={ShippedSales} />}
			/>
			<Route
				path="/clients"
				element={<ProtectedRoute element={Clients} />}
			/>
			<Route path="*" element={<NotFound />} />
		</Routes>
	)
}

export default RoutesComponent
